import { render, staticRenderFns } from "./LeilaoInfo.vue?vue&type=template&id=3fe4c5a2&"
import script from "./LeilaoInfo.vue?vue&type=script&lang=js&"
export * from "./LeilaoInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports